import { Paper, Toolbar, Typography } from '@material-ui/core';
import qs from 'query-string';
import React from 'react';
import Layout from '../../../common/components/Layout';
import ReturnButton from '../../../common/components/ReturnButton';
import { SimpleBreadcrumbs } from '../../../common/components/SimpleBreadcrumbs';
import { getProject } from '../../../common/services/project';
import { MatchVideoForm } from '../components/MatchVideoForm.component';
import { IMatchVideoPayload } from '../typings';
import { IComponentProps } from './AddMatchVideo.connector';

interface IState {
  saving: boolean;
}

export class AddMatchVideo extends React.Component<IComponentProps, IState> {
  public state: IState = { saving: false };

  public render() {
    const {
      intl: { messages: m },
      location,
    } = this.props;
    // Pre-selected match when coming from the match page (?match=<iri>).
    const { match } = qs.parse(location.search);

    return (
      <Layout
        id="match-video-add-layout"
        top={
          <SimpleBreadcrumbs
            crumbStack={[{ labelKey: 'app_matchVideos', href: `#${getProject().url}/match-videos` }]}
          />
        }
        main={
          <Paper elevation={2}>
            <Toolbar>
              <Typography variant="h6">{m.app_matchVideoAdd}</Typography>
              <div style={{ flex: 1 }} />
              <ReturnButton entity="match-videos" />
            </Toolbar>
            <MatchVideoForm
              fixedMatch={typeof match === 'string' ? match : null}
              saving={this.state.saving}
              onSubmit={this.handleSubmit}
            />
          </Paper>
        }
      />
    );
  }

  private handleSubmit = (payload: IMatchVideoPayload) => {
    const { addMatchVideo, history } = this.props;

    this.setState({ saving: true });
    // @ts-ignore - thunk returns a promise resolving to the dispatched action
    addMatchVideo(payload).then(({ type, payload: created }) => {
      this.setState({ saving: false });
      if (type === 'ADD_MATCH_VIDEO_FULFILLED' && created && created.id) {
        history.push(`${getProject().url}/match-videos/${created.id}`);
      }
    });
  };
}
